import React from 'react'
// import { useParams } from 'react-router-dom';
import Container from '../../components/container';
import HeaderHome from '../../components/header';
import FooterHome from '../../components/footer';
import Content from './content';
import '../../assets/styles/scss/pages/_applicantProfile.scss'
import { DropdownDataProvider } from './context/dropdownDataContext';

const ApplicantProfile = () => {
    // const { email } = useParams();
    // console.log('email', email)

    return (
        <Container>
            <header className='div-header'>
                <HeaderHome />
            </header>
            <div className="app-profile relative" >
                <DropdownDataProvider>
                    <Content />
                </DropdownDataProvider>
            </div>
            <footer>
                <FooterHome />
            </footer>
        </Container>
    )
}

export default ApplicantProfile